module.exports = __webpack_public_path__ + "static/piyango-mobil-124b593c9402606d40e81b50b6b6a749.png";